import React from "react";

import copy from "../../data/copy.js";

import CabinetCopy from "./CabinetCopy";

export default class CabinetResources extends React.Component {
  componentDidMount() {
    document.getElementById("scroll-case").parentNode.scrollTop = 0;
  }
  render() {
    return (
      <div className="cabinet-file-content">
        <h1>{copy[this.props.languageId].cabinet.terms.untertitle}</h1>
        <div className="title-separator" />
        <div className="cabinet-body-text">
          <CabinetCopy languageId={this.props.languageId} section={"about"} />
          <div className="logo-wrapper">
            <img src="/assets/logo-fa.jpg" />
            {/* <img src="/assets/logo-as.jpg" /> */}
            {/* <img src="/assets/logo-pl.jpg" /> */}
            {/* <img src="/assets/logo-zc.jpg" /> */}
            <img src="/assets/logo-village.jpg" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/CabinetProject.jsx